import React, { useContext, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Redirect } from "react-router-dom";
import { NikeI18nContext } from "@nike/i18n-react";
import { connect } from "react-redux";
import jwtDecode from "jwt-decode";
import localStorageService from "../../services/localStorage";

import Button from "../../components/Button";
import { Actions as loginActions } from "../../modules/login";

import { OKTA, TRUE_AUTH_SOURCE } from "../../constants/common";

import ts from "./login.i18n";

/**
 * The coorporate or employee w/ a nike email login form
 * The okta login button, okta react handles the actual redirect
 * @param {function} loginOktaAuth - when called will set the login state for retail auth
 */
const OktaLogin = ({ loginOktaAuth }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const { i18nString } = useContext(NikeI18nContext);

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (authState.isAuthenticated === true && authState.accessToken) {
      localStorage.setItem(TRUE_AUTH_SOURCE, OKTA);

      try {
        // In @okta/okta-auth-js v6+ the JWT string is at accessToken.accessToken
        const token = authState.accessToken.accessToken;

        if (!token || typeof token !== "string") {
          console.error("Invalid token format:", token);
          console.error("accessToken structure:", authState.accessToken);
          return;
        }

        const decodedToken = jwtDecode(token);

        const storeDetails = localStorageService.getStoreId();
        const authSource = localStorageService.getAuthSource();

        loginOktaAuth(decodedToken, storeDetails, authSource);
      } catch (error) {
        console.error("Error decoding token:", error);
        console.error("Token structure:", authState.accessToken);
        return;
      }
    }
  }, [authState, loginOktaAuth]);

  const login = async () => {
    try {
      await oktaAuth.signInWithRedirect({
        originalUri: "/applications",
      });
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  if (!authState || !oktaAuth) {
    return <div>Loading authentication...</div>;
  }

  if (authState.isAuthenticated === true) {
    return <Redirect to="/applications" />;
  }

  return (
    <div>
      <Button
        onClick={() => login()}
        buttonText={i18nString(ts.LOGIN_OKTA_BUTTON)}
        testId="okta-login-button"
      />
    </div>
  );
};

export const mapDispatchToProps = (dispatch) => ({
  loginOktaAuth: loginActions.loginOktaAuth(dispatch),
});

export default connect(null, mapDispatchToProps)(OktaLogin);
